.backdrop {
  /* Override defaults */
  position: fixed;
  display: grid;
  top: 0;
  left: 0;
  right: 0;
  bottom: auto;
  max-width: none;
  max-height: none;
  border: none;
  width: 100vw;
  height: 100vh;
  /* biome-ignore lint/suspicious/noDuplicateProperties: Including 100vh as a fallback for browsers that don't support dvh */
  height: 100dvh;
  align-items: center;
  z-index: 1;
  overflow: hidden;

  /* Styles */
  backdrop-filter: blur(16px);
  padding: 0;
  background: #0004;

  transition: opacity 300ms ease;

  &:not([open]) {
    pointer-events: none;
    opacity: 0;
  }

  @media (prefers-reduced-motion: no-preference) {
    .dialog {
      animation: slideDown 300ms ease forwards;
    }

    &[open] .dialog {
      animation: slideUp 300ms ease forwards;
    }
  }

  @media (prefers-reduced-motion: no-preference) and (min-width: 480px) {
    .dialog {
      animation: shrink 300ms ease forwards;
    }

    &[open] .dialog {
      animation: grow 300ms ease forwards;
    }

    .drawer {
      animation: slideLeft 300ms ease forwards;
    }

    &[open] .drawer {
      animation: slideRight 300ms ease forwards;
    }
  }

  &::backdrop {
    opacity: 0;
  }

  & .dialog {
    padding: 16px 20px;
    height: 100svh;
    overflow-y: auto;

    @media (min-width: 480px) {
      height: auto;
      border-radius: 8px;
      margin: 20px auto;
      border: 1px solid var(--color-parchment-dark);
      max-height: calc(100svh - 40px);
    }

    & header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 8px;

      & button {
        width: 44px;
        height: 44px;
        border-radius: 50%;
        border: none;
        text-decoration: none;
        padding: 0;
        flex-shrink: 0;

        svg {
          width: 24px;
          height: 24px;
          flex-shrink: 0;
          fill: var(--color-accent);
        }
      }
    }

    &.drawer {
      position: absolute;
      left: 0;
      top: 0;
      margin: 0;
      height: 100%;
      width: 100%;
      border-radius: 0;
      overflow-y: auto;
      padding: 4px 16px 16px;
      max-height: none;

      @media (min-width: 480px) {
        width: 375px;
      }

      & header {
        border-bottom: 1px solid #caac8e;
        margin: -4px -16px 32px;
        padding: 4px 16px;
      }
    }
  }
}

@keyframes shrink {
  to {
    transform: scale(0);
  }
}

@keyframes grow {
  from {
    transform: scale(0);
  }
}

@keyframes slideLeft {
  to {
    transform: translateX(-375px);
  }
}

@keyframes slideRight {
  from {
    transform: translateX(-375px);
  }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(200px);
  }
}

@keyframes slideDown {
  to {
    opacity: 0;
    transform: translateY(200px);
  }
}
